import React, { createContext, useContext, useState, useEffect } from 'react';
import { authAPI } from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser]       = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      authAPI.me()
        .then(r => setUser(r.data))
        .catch(() => { localStorage.removeItem('token'); setLoading(false); })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const loginWithGoogle = async (credential) => {
    const r = await authAPI.googleLogin(credential);
    localStorage.setItem('token', r.data.token);
    setUser(r.data);
  };

  const loginWithEmail = async (email, password) => {
    const r = await authAPI.emailLogin(email, password);
    localStorage.setItem('token', r.data.token);
    setUser(r.data);
  };

  /**
   * Hard-gate register: creates the user on the backend and triggers the
   * verification email but does NOT issue a session JWT. The caller is
   * expected to show a "check your inbox" screen. Logging in happens only
   * when the user clicks the verification link (VerifyEmailPage stores the
   * token + user it gets back).
   */
  const register = async (name, email, password) => {
    const r = await authAPI.register(name, email, password);
    return r.data; // shape: { pending: true, email, message }
  };

  /** Used by VerifyEmailPage after a successful click on the verification link.
   *  Backend returns the full AuthResponse (token + user fields) — same shape
   *  loginWithEmail/loginWithGoogle handle. */
  const finalizeSession = (authResponse) => {
    if (authResponse?.token) {
      localStorage.setItem('token', authResponse.token);
    }
    setUser(authResponse);
  };

  const logout = () => {
    localStorage.removeItem('token');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, loginWithGoogle, loginWithEmail, register, finalizeSession, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
